<template>
  <div class="page">
    <div class="box">
      <img class="layer" src="../assets/img_37288_0_0.jpg" />
      <van-popup
        round
        :close-on-click-overlay="false"
        overlay-class="overlaymain"
        lock-scroll
        v-model="showmain"
        style="width:30%; "
      >
        <div class="warp-grid">
          <h4>请输入用户名密码验证访问权限</h4>
          <!-- <p align="center">登录手机号+密码：<br>银花街道17921728907|同乐街道15810790520</p> -->
          <p align="center" v-if="orgName">当前登录用户：{{orgName}}{{username}}， <a @click="logout">退出</a></p>
          <van-form @submit="onSubmit" v-else>
            <van-field
              v-model="username"
              left-icon="manager"
              name="username"
              label="用户名"
              placeholder="可输手机号"
              :rules="[{required: true, message: '请填写用户名'}]"
            />
            <van-field
              v-model="password"
              left-icon="lock"
              type="password"
              name="password"
              label="密码"
              placeholder="请输入密码"
              :rules="[{required: true, message: '请填写密码'}]"
            />
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">
                提交
              </van-button>
              <p align="right"><span style="color:#0d2b31; cursor: help; font-size: 12px;" @click="getOrgList">街道列表</span>
              <ul class="liorg" v-if="iShow"><li v-for="item in streetList" :key="item.code"><a @click="getOrgPhone(item.code)">{{item.title}}</a></li></ul>
              </p>
            </div>
          </van-form>
        </div>
      </van-popup>

      <div class="tips">
        提示：请使用国内主流浏览器（QQ浏览器、Chrome浏览器）最新版打开！大屏显示分辨率设为1920X1080是最佳浏览效果。<br>ICP备案号：<a href="https://beian.miit.gov.cn/" target="_blank">皖ICP备2020017520号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/api/api'

export default {
  name: 'login',
  data() {
    return {
      iShow: false,
      showmain: true,
      isLogin: false,
      username: '',
      password: '',
      orgName: localStorage.getItem('orgName'),
      orgImg: this.GLOBAL.url().imgURL,
      streetList: [
        {code: '13411020100', title: '琅琊街道'},
        {code: '13411020110', title: '遵阳街道'},
        {code: '13411020120', title: '丰山街道'},
        {code: '13411020130', title: '清流街道'},
        {code: '13411020140', title: '扬子街道'},
        {code: '13411020150', title: '西涧街道'},
        {code: '13411020160', title: '滁阳街道'},
        {code: '13411020170', title: '三官街道'},
        {code: '13411030010', title: '龙蟠街道'},
        {code: '13411030030', title: '同乐街道'},
        {code: '13411030040', title: '银花街道'},
        {code: '13411710010', title: '大王街道'},
        {code: '13411020180', title: '凤凰办事处'},
        {code: '13411020190', title: '城北新区'},
      ]
    }
  },
  components: {},
  methods: {
    goLink(name, id) {
      this.$router.push({
        name: name,
        params: {orgId: id}
      })
    },
    getOrgList() {
      this.iShow = true
    },
    getOrgPhone(id) {
      this.username = id
      this.iShow = false
    },
    onSubmit(values) {
      console.log('submit', values)
      return new Promise((resolve, reject) => {
        ApiService.login(values)
          .then((res) => {
            if (res.code === 0 && values.username !== '123') {
              this.$toast.success('登录成功')
              localStorage.setItem('user_token', res.data.accessToken)
              localStorage.setItem('user_name', values.username)
              this.getuserInfo()
            } else {
              this.$toast.fail('登录失败，请确认用户名密码是否正确')
            }
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {})
      })
    },
    getuserInfo() {
      return new Promise((resolve, reject) => {
          ApiService.userInfo()
          .then((res) => {
            if (res.code === 0) {
              if (res.data.roleId.indexOf('39') > -1) {
                localStorage.setItem('orgId', res.data.orgId)
                localStorage.setItem('roleId', res.data.roleId)
                this.orgName = res.data.uname
                this.goLink('home', res.data.orgId)
              } else {
                this.$toast.fail('登录失败，非街道权限账号！')
                this.logout()
                // this.goLink('login', res.data.orgId)
              }
            }
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {})
      })
    },
    logout() {
      const token = localStorage.getItem('user_token')
      if(token) {
        localStorage.removeItem('user_token')
        localStorage.removeItem('orgId')
        localStorage.removeItem('orgName')
        localStorage.removeItem('areaName')
        localStorage.removeItem('orgLogo')
      }
      this.orgName = ''
    }
  },
  mounted() {
    const user_name = localStorage.getItem('user_name')
    if (user_name) {
      this.username = user_name
    }
  },
  created: function() {}
}
</script>

<style>
.van-form {
  margin-top: 2vw;
}
.van-form .van-cell {
  font-size: 0.933vw;
  color: #59f9ff;
  background: #143137;
  border: 1px #0d2b31 solid;
  width: 95%;
  margin: 10px;
}
.van-form .van-field__left-icon .van-icon {
  font-size: 0.933vw;
}
.van-form .van-cell::after {
  border: none;
}
.van-form .van-button--normal {
  font-size: 0.933vw;
  width: 95%;
}
.van-form .van-field__control {
  color: #ffffff;
}
.overlaymain {
  background: none;
}
.tips {
  position: absolute;
  bottom: 20%;
  text-align: center;
  color: #59f9ff;
  font-size: 16px;
  z-index: 9999;
}
.liorg {
  display: flex;
}
.liorg li { 
  margin: 5px 10px;
  line-height: 120%;
  font-size: 16px;
}
</style>
